import React from 'react';
import PropTypes from 'prop-types';
import { BreadcrumbsContainer, LinksContainer } from './CourseHome.styles';
import BreadCrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import PresentationIcon from '../../Visuals/Icons/PresentationIcon.icon';
import LinkIcon from '../../Visuals/Icons/LinkIcon.icon';
import PlayIcon from '../../Visuals/Icons/PlayIcon.icon';
const CourseSideMenu = ({ course, status }) => {
  return (
    <>
      <LinksContainer>
        <BreadcrumbsContainer>
          <BreadCrumbs
            one="My Dashboard"
            oneLink="/user"
            two={course?.courseName}
          />
        </BreadcrumbsContainer>
        <a href="#presentation">
          <PresentationIcon /> Presentation
        </a>
        {course?.attachments?.length ? (
          <a href="#documentation">
            <LinkIcon />
            Documentation
          </a>
        ) : null}
        {course?.videoLinks?.length ? (
          <a href="#videos">
            <PlayIcon />
            Video Links
          </a>
        ) : null}
        <span className="courseStatus">{status}</span>
      </LinksContainer>
    </>
  );
};
CourseSideMenu.propTypes = {
  course: PropTypes.shape({
    courseName: PropTypes.string,
    attachments: PropTypes.arrayOf(PropTypes.string),
    videoLinks: PropTypes.arrayOf(PropTypes.string),
  }),
  id: PropTypes.string,
  status: PropTypes.string,
};

export default CourseSideMenu;
